var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgList(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13083",
    transform: "translate(-1680 1859)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_667",
    transform: "translate(1680 -1859)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 7.3,
    cy: 7.7,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M7.3,13.3c-3.1,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5S10.4,13.3,7.3,13.3z M7.3,5.9 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S8.4,5.9,7.3,5.9z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_668",
    transform: "translate(1680 -1851)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 7.3,
    cy: 14.5,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M7.3,20c-3.1,0-5.5-2.5-5.5-5.5S4.3,9,7.3,9s5.5,2.5,5.5,5.5S10.4,20,7.3,20z M7.3,12.7 c-1,0-1.8,0.8-1.8,1.8s0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8S8.4,12.7,7.3,12.7z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_669",
    transform: "translate(1680 -1843)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    cx: 7.3,
    cy: 21.3,
    r: 5.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M7.3,26.8c-3.1,0-5.5-2.5-5.5-5.5s2.5-5.5,5.5-5.5s5.5,2.5,5.5,5.5S10.4,26.8,7.3,26.8z M7.3,19.4 c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8s1.8-0.8,1.8-1.8C9.2,20.2,8.4,19.4,7.3,19.4z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M1721.4-1849.4h-22.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h22.8c1,0,1.8,0.8,1.8,1.8 C1723.2-1850.2,1722.4-1849.4,1721.4-1849.4z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M1721.4-1834.7h-22.8c-1,0-1.8-0.8-1.8-1.8s0.8-1.8,1.8-1.8h22.8c1,0,1.8,0.8,1.8,1.8 S1722.4-1834.7,1721.4-1834.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#414141",
    d: "M1721.4-1819.9h-22.8c-1,0-1.8-0.8-1.8-1.8c0-1,0.8-1.8,1.8-1.8h22.8c1,0,1.8,0.8,1.8,1.8 C1723.2-1820.7,1722.4-1819.9,1721.4-1819.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgList);
export default __webpack_public_path__ + "static/media/List.54154c7f4f019648f057542b593a8cdb.svg";
export { ForwardRef as ReactComponent };